import { render, staticRenderFns } from "./BigSlider.vue?vue&type=template&id=66bd2767&scoped=true&"
import script from "./BigSlider.vue?vue&type=script&lang=js&"
export * from "./BigSlider.vue?vue&type=script&lang=js&"
import style0 from "./BigSlider.vue?vue&type=style&index=0&id=66bd2767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd2767",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigSlider.vue
// module id = 263
// module chunks = 0